export default __webpack_public_path__ + "static/tour-example1-f4b9c3103b302cc267a7071abb93133d.png";